function ApplicationCore() {

}

ApplicationCore.utilities = {
    // This will remove the pre-set settings in the application.
    removeApplicationObj: function(settingsObject) {
        delete settingsObject.custom_obj;
        delete settingsObject.scale_type;
        delete settingsObject.custom_size_type;
        delete settingsObject.application.views[0].application.scale;
    },
    
    /*
        This will change the mascot of the application 
        @params application object and mascot ID
    */
    changeMascot: function(_mascotID, settingsObj) {
        var _mascotObj = _.find(ub.data.mascots, {id: _mascotID.toString()});
        var _id = settingsObj.id;
        var _layerCount = _.size(_mascotObj.layers_properties);

        ub.funcs.removeApplicationByID(_id);
        settingsObj.mascot = _mascotObj;

        if (_mascotID !== '1039') {
            settingsObj.color_array = ub.funcs.getDefaultColors();

            // Single Layer Mascot default
            if (_layerCount === 1) {
                settingsObj.color_array = [settingsObj.color_array[0]];
            }

        } else {
            settingsObj.color_array = [];
            settingsObj.color_array.push(ub.funcs.getColorByColorCode('W'));
            settingsObj.color_array.push(ub.funcs.getColorByColorCode('RB'));
            settingsObj.color_array.push(ub.funcs.getColorByColorCode('R'));
        }

        // Reset flip when changing new mascot
        _.each(settingsObj.application.views, function (v) {
            v.application.flip = 0;
        });

        ub.funcs.update_application_mascot(settingsObj.application, settingsObj.mascot);
        ub.funcs.activateMoveTool(settingsObj.code);
    },

    /*
        This will change the accent of the text application.
        @params accentID, application
    */
    changeAccent: function(accentID, application) {
        var _accentObj = _.find(ub.data.accents.items, {id: parseInt(accentID)});
        var _id = application.id;
        ub.funcs.removeApplicationByID(_id);

        /// Process new Colors
        var _toggle = false;
        var colorArray = [];
        var colorArrayText = [];

        // Process colors of accent
        _.each(_accentObj.layers, function (layer) {
            if (layer.name === 'Mask' || layer.name === 'Pseudo Shadow') {
                return;
            }
            var _layerNo = layer.layer_no - 1;

            _color = application.color_array[_layerNo];

            if (typeof _color === 'undefined') {
                _color = ub.data.secondaryColorPalette[_layerNo];
            }

            layer.default_color = _color.hex_code;

            colorArray.push(_color);
            colorArrayText.push(_color.color_code);
        });

        application.color_array = colorArray;
        application.colorArrayText = colorArrayText;

        /// trim new colors
        var _accentObjLength = (_accentObj.layers.length - 1);
        ub.accentObj = _accentObj;
        /// end trim new colors

        /// Matching Colors
        _matchingCode = ub.data.matchingIDs.getMatchingID(application.code);
        if (typeof _matchingCode !== "undefined") {
            _matchingSettingsObject = ub.funcs.getApplicationSettings(_matchingCode.toString());
            if (typeof _matchingSettingsObject !== 'undefined') {
                _matchingSettingsObject.color_array = application.color_array;
                _matchingSettingsObject.colorArrayText = application.colorArrayText;
            }
        }
        /// End Matching Colors

        application.accent_obj = _accentObj
        ub.create_application(application, undefined);
    },

    /*
        This will apply the text shape in uniform. By updating the embellishment data of the application
        @params application, embellishment
    */
    updateEmbellishment: function(application, embellishment, options) {
        var settings = ub.current_material.settings;
        var application_embellishment_code = application.id + '_' + embellishment.id;
        var scale_settings;
        var _status;

        if(typeof settings.applications[application.id] !== 'undefined'){
            scale_settings = settings.applications[application.id].scale;
        }

        var settings_obj = settings.applications[application.id];

        settings_obj.font_size = settings_obj.size;

        var embellishment_obj = settings_obj.embellishment;
        var view = ub[application.perspective + '_view'];
        var view_objects = ub.objects[application.perspective + '_view'];

        settings_obj.embellishment = embellishment;
        settings_obj.fromChangeColor = (typeof options !== "undefined");

        var sprite_collection = ub.funcs.renderApplication($.ub.create_embellishment, settings_obj, application.id);
        var uniform_type = ub.current_material.material.type;
        var app_containers = ub.current_material.containers[uniform_type].application_containers;
        var sprite = sprite_collection;

        app_containers[application.id] = {};
        app_containers[application.id].object = {

            sprite: sprite_collection,

        };

        _status = settings_obj.status;

        if (typeof settings_obj.status === "undefined") {
            _status = "on";
        }

        ub.funcs.toggleApplication(application.id, _status);

        if (ub.data.afterLoadCalled === 0) { return; } // Skip activate when called on load prep

        ub.funcs.updateLayerTool();
    },

    /*
        This will open the font modal (Team name, Player number and name)
        @params text, application
    */
    openFontModal: function(text, application) {
        FontModal.funcs.loadFontModal(text, application);
    },
    
    /*
        This will check the length of the input text
    */
    maxLengthCheck: function (object) {
        if (object.value.length > object.max.length) {
            object.value = object.value.slice(0, object.max.length)
        }
    },

    /*
        This will check if the text contains numbers
    */
    hasNumber: function (text) {
        return /\d/.test(text);
    },

    /*
        This will check if the text contains letters
    */
    hasLetter: function (text) {
      return /[A-Za-z]/.test(text);
    },

    getDesignDetails: function(inksoftID, successHandler, errorHandler) {
        var url = ub.config.api_host + "/api/v1-0/inksoft_design/getByDesignID/" + inksoftID;
        ub.utilities.getJSON(url, successHandler, errorHandler);
    },

    // Get All Mascot
    getAllMascot: function() {
        // Get applications and filter
        var _Applications = ub.current_material.settings.applications;
        var _filteredApplications = _.filter(_Applications, function(i) {
            if (i.application_type === 'mascot' || i.application_type === 'embellishments') {
                if (i.logo_type !== "custom_text") {
                    return i;
                }
            }
        });

        return _filteredApplications;
    },

    getAllEmbellishments: function(withConflict = false) {
        var applications = ub.current_material.settings.applications;
        var embellishment = _.filter(applications, function(application) {
            if (application.application_type === 'embellishments' && !TextShapeCore.utilities.isTextShape(application.code)) {
                if (withConflict) {
                    if (application.hasConflict) {
                        return application;
                    }
                } else {
                    return application;
                }
            }
        });

        return embellishment;
    }
}

ApplicationCore.funcs = {
    utilities: ApplicationCore.utilities,
    /*
        This will create new application object
        @params perspective, part, side, callback
        @return application settings
    */
    createNewApplication: function(perspective, part, side, callback) {
        var _pha = _.find(ub.data.placeHolderApplications, {perspective: perspective});
        var _phaSettings = ub.utilities.cloneObject(ub.data.placeholderApplicationSettings[_pha.id]);
        var _part = part;
        var _sport = ub.current_material.material.uniform_category;
        var _blockPattern = ub.current_material.material.block_pattern;
        var _primaryView = ub.funcs.getPrimaryView(_phaSettings.application);
        var _primaryViewObject = ub.funcs.getPrimaryViewObject(_phaSettings.application);

        var _withPlaceholderOverrides = false; // Placeholder overrides set on the backend
        var _perspectiveMarkForDeletion = undefined;

        // Process Uniforms with Extra Layer

        if (ub.data.sportsWithExtraLayer.isValid(ub.current_material.materials_options)) {
            var _extra = ub.objects[perspective + '_view']['extra'];

            if (typeof _extra === "undefined") {
                ub.utilities.error('Extra Layer not detected!');
            }

            if (typeof _extra !== "undefined") {
                var whiteList = ['Body', 'Front Body', 'Back Body', 'Body Left', 'Body Right'];

                if (_.contains(whiteList, _part)) {
                    _part = 'Extra';
                }
            }
        }

        var _exempted = ub.data.applicationProjectionExemptions.isExempted(perspective, part, ub.config.sport);

        // For Cowls, etc which uses a non-standard primary perspectives
        if (_exempted.isExempted) {
            var _primaryViewFound = _.find(_phaSettings.application.views, {perspective: _exempted.result.primary});

            if (typeof _primaryViewFound !== "undefined") {
                _primaryViewFound.application.isPrimary = 1;
                _primaryViewObject = _primaryViewFound;
                _phaSettings.application.views = _.filter(_phaSettings.application.views, function (view) {
                    var _ok = view.perspective !== "left" && view.perspective !== "right" && (_primaryView === "front") ? view.perspective === "back" : view.perspective === "front";
                    return _ok;
                });
            }

            ub.funcs.setActiveView('front');
        }

        // For instances where the part has left or right (e.g. sleeve), converts it to Left Sleeve
        if (typeof side !== "undefined" && side !== "na") {
            _part = side.toTitleCase() + " " + _part;
        }

        // Set Mascots Only for now on Socks
        _phaSettings.validApplicationTypes = ub.data.freeFormValidTypes.getItem(ub.current_material.material.uniform_category, _part).validTypes;
        _.each(_phaSettings.application.views, function (_perspectiveView) {
            var _perspective = _perspectiveView.perspective;

            // Get Center of Polygon
            var _cx = ub.funcs.getCentoid(_perspective, _part);

            // CX Override
            if (typeof _cx !== "undefined") {
                _perspectiveView.application.center = _cx;
                _perspectiveView.application.pivot = _cx;
            }

            if (typeof _perspectiveView !== "undefined") {
                var _overrides = ub.data.placeHolderOverrides.getOverrides(_sport, _part, _perspectiveView.perspective, _blockPattern);

                if (typeof _overrides !== "undefined") {
                    _withPlaceholderOverrides = true;
                    _perspectiveView.application.rotation = _overrides.rotation;
                    _perspectiveView.application.center = _overrides.position;
                    _perspectiveView.application.pivot = _overrides.position;
                } else {
                    // If has a placeholder override but this particular view has none set delete
                    if (_withPlaceholderOverrides) {
                        _perspectiveMarkForDeletion = _perspectiveView.perspective;
                    }
                }
            }
        });

        if (typeof _perspectiveMarkForDeletion !== "undefined") {
            _phaSettings.application.views = _.filter(_phaSettings.application.views, function (view) {
                return view.perspective !== _perspectiveMarkForDeletion;
            });
        }

        _.each(_phaSettings.application.views, function (_perspectiveView) {
            // Get Center of Polygon
            var _cx = ub.funcs.getCentoid(_perspectiveView.perspective, _part);
            var _overrides = ub.data.placeHolderOverrides.getOverrides(_sport, _part, _perspectiveView.perspective, _blockPattern);

            // CX Override
            if (typeof _cx !== "undefined" && typeof _overrides === "undefined") {
                _perspectiveView.application.center = _cx;
                _perspectiveView.application.pivot = _cx;
            }

            if (typeof _perspectiveView !== "undefined" && typeof _overrides === "undefined") {
                if (parseInt(_perspectiveView.application.isPrimary) !== 1) {
                    var _bounds = ub.funcs.getBoundaries(_perspectiveView.perspective, _part, false);
                    var _overrideX = undefined;

                    if (_primaryView === "front") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "left") {
                                _overrideX = _bounds.minMax.minX;
                            }
                            
                            if (_perspectiveView.perspective === "right") {
                                _overrideX = _bounds.minMax.maxX;
                            }
                        }
                    }

                    if (_primaryView === "back") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "left") {
                                _overrideX = _bounds.minMax.maxX;
                            }
                            
                            if (_perspectiveView.perspective === "right") {
                                _overrideX = _bounds.minMax.minX;
                            }
                        }
                    }

                    if (_primaryView === "right") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "front") {
                                _overrideX = _bounds.minMax.minX;
                            }
                            
                            if (_perspectiveView.perspective === "back") {
                                _overrideX = _bounds.minMax.maxX;
                            }
                        }
                    }

                    if (_primaryView === "left") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "front") {
                                _overrideX = _bounds.minMax.maxX;
                            }
                            
                            if (_perspectiveView.perspective === "back") {
                                _overrideX = _bounds.minMax.minX;
                            }
                        }
                    }

                    _perspectiveView.application.position = {x: _overrideX, y: _primaryViewObject.application.center.x};
                    _perspectiveView.application.center = {x: _overrideX, y: _primaryViewObject.application.center.y};
                }
            }
        });

        var _newID = ub.funcs.getNewCustomID();
        var _newApplication = JSON.parse(JSON.stringify(_phaSettings)); // Quick Clone
        _newID = _newID;
        _newIDStr = _newID.toString();
        _newApplication.code = _newIDStr;
        _newApplication.application.id = _newIDStr;
        _newApplication.configurationSource = "Added";
        _newApplication.zIndex = ub.funcs.getNewZIndex();

        // Set Default Sizes
        _newApplication.application_size = "as_shown";
        _newApplication.size_type = "tall";

        if (ub.data.placeHolderOverrideSports.isValid(ub.sport)) {
            var _tmp = [];

            _.each(_newApplication.application.views, function (view) {
                view.application.id = _newIDStr;

                // For Socks push only the primary perspective
                if (ub.funcs.isSocks()) {
                    if (view.application.isPrimary === 1) {
                        _tmp.push(view);
                    }
                } else {
                    _tmp.push(view);
                }
            });

            _newApplication.application.views = _tmp;
        }

        var _withBodyLeftRight = ub.data.withBodyLeftRight.isOk(ub.sport, ub.neckOption);

        if (_withBodyLeftRight) {

            if (_part === "Body Left") {
                _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                    return view.perspective !== "right";
                });
            }

            if (_part === "Body Right") {
                _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                    return view.perspective !== "left";
                });
            }

        }

        // Cinch Sack doens't have a left and right perspective
        if (ub.sport === "Cinch Sack (Apparel)") {
            _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                return view.perspective !== "left" && view.perspective !== "right";
            });
        }

        var _isSingleView = ub.data.categoriesWithSingleViewApplications.getItem(ub.config.sport, ub.config.type, ub.config.blockPattern, ub.config.option);

        if (_isSingleView) {
            _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                return view.application.isPrimary === 1;
            });
        }

        ub.current_material.settings.applications[_newIDStr] = _newApplication;
        _newApplication.application.layer = _part;

        if (typeof ub.data.applications_transformed[_part] !== 'undefined') {
            ub.data.applications_transformed[_part][_newIDStr] = _newApplication.application;
            _newApplication.application.layer = _part;
        } else {
            if (typeof ub.data.applications_transformed["Body Panel Color"] !== 'undefined') {
                _newApplication.application.layer = "Body Panel Color";
                ub.data.applications_transformed["Body Panel Color"][_newIDStr] = _newApplication.application;
            }
        }

        ub.data.applications_transformed_one_dimensional[_newIDStr] = _newApplication.application;
        ub.funcs.renderLocations(_newIDStr);
        ub.funcs.pushOldState('add location', 'application', _newApplication, {applicationID: _newIDStr});
        ub.funcs.updateLayerTool();

        if (_.isFunction(callback)) {
            callback(_newApplication);
        }
    },
    /*
        This will create new team name
        @params perspective, part, side
    */
    createNewTeamName: function(perspective, part, side, callback) {
        var self = this;
        self.createNewApplication(perspective, part, side, function(app) {
            self.utilities.removeApplicationObj(app);
            var _settingsObject = app;
            var _id = parseInt(_settingsObject.code);

            var _applicationType = 'team_name';
            var _size = 2;
            
            if (ub.funcs.isCurrentSport('Wrestling')) { _size = 4; }
            if (ub.funcs.isCurrentSport('Baseball')) { _size = 5; }

            if (_.isEqual(ub.config.blockPattern, 'Hockey Twill Set-in')) { 
                _size = 2.5;
            }

            if (ub.funcs.isCurrentSport('Baseball') && ub.config.brand.toLowerCase() === "richardson") {
                _size = 2.5;
            }

            ub.funcs.setAppSize(_id, _size);

            _settingsObject.text = ub.funcs.getSampleTeamName();
            _settingsObject.accent_obj = ub.funcs.getSampleAccent();
            _settingsObject.application_type = _applicationType;
            _settingsObject.type = _applicationType;
            _settingsObject.object_type = 'text object';
            _settingsObject.font_obj = ub.funcs.getSampleFont();
            _settingsObject.color_array = ub.funcs.getDefaultColors();

            if (_settingsObject.color_array.length > 1) {
                _settingsObject.color_array = [_settingsObject.color_array[0]];
            }

            _settingsObject.application.name = _applicationType.toTitleCase();
            _settingsObject.application.type = _applicationType;

            // Activate Application
            _settingsObject.status = "on";

            // Set Pattern to Blank
            ub.funcs.setApplicationPatternToDefault(_settingsObject, "318");
            ub.create_application(_settingsObject, undefined);

            ub.current_material.settings.applications[_id] = _settingsObject;
            ub.funcs.LSRSBSFS(parseInt(_id));

            delete ub.current_material.settings.applications[_id].application.views[0].application.appCustomScale;

            ub.data.currentApplication = _settingsObject;
            ub.funcs.runAfterUpdate(_id);

            if (_.isFunction(callback)) {
                callback(_settingsObject);
            }
        });
    },

     /*
        This will create new stock mascot (Embellishment)
        @params perspective, part, side, logo_type, location
    */
    createNewEmbellishments: function(perspective, part, side, logo_type, location) {
        var self = this;
        self.createNewApplication(perspective, part, side, function(app) {
            var _settingsObject = app;
            var _id = parseInt(_settingsObject.code);

            var _applicationType = 'embellishments';
            var _size = 4;
            var _embellishmentID;
            
            if (ub.config.brand.toLowerCase() === "richardson") {
                if (logo_type === "stock") {
                    _embellishmentID = 1762241;
                } else if (logo_type === "custom") {
                    _embellishmentID = 1722159;
                } else if (logo_type === "custom_text") {
                    _embellishmentID = 1722239;
                }
            } else {
                _embellishmentID = 1722159;
            }

            ub.funcs.deActivateApplications();
            _settingsObject.font_obj = ub.funcs.getSampleFont();
            _settingsObject.application_type = _applicationType;
            _settingsObject.type = _applicationType;
            _settingsObject.object_type = _applicationType;
            _settingsObject.color_array = ub.funcs.getDefaultColors();

            _settingsObject.application.name = _applicationType.toTitleCase();
            _settingsObject.application.type = _applicationType;
            _settingsObject.logo_type = logo_type;
            _settingsObject.location = location;
            ub.funcs.setAppSize(_id, _size);

            // Activate Application
            _settingsObject.status = "on";

            ub.current_material.settings.applications[_id] = _settingsObject;
            ub.funcs.LSRSBSFS(parseInt(_id));

            ub.data.currentApplication = _settingsObject;
            ub.funcs.runAfterUpdate(_id);

            if (_settingsObject.logo_type === 'custom') {
                if (typeof ub.user.id === "undefined" || typeof is.embellishments.userItems === "undefined" || is.embellishments.userItems.length === 0) {
                    InteropIsPanel.funcs.loadDesignerUpload(undefined, _settingsObject.code, true);
                } else {
                    InteropIsPanel.funcs.loadExistingDesign(_settingsObject);
                }
            } else if (_settingsObject.logo_type === 'stock') {
                StockMascot.events.init();
            } else if (_settingsObject.logo_type === 'custom_text') {
                StockMascot.events.init(ub.data.customTextCategoryID);
            }
        });
    },

     /*
        This will create new player name
        @params perspective, part, side
    */
    createNewPlayerName: function(perspective, part, side) {
        var self = this;
        self.createNewApplication(perspective, part, side, function(app) {
            var _settingsObject = app;
            var _id = parseInt(_settingsObject.code);

            var _applicationType = 'player_name';
            var _size = 2.5;

            if (ub.funcs.isCurrentSport('Baseball') && ub.config.brand.toLowerCase() === "richardson") {
                _size = 2.5;
            }
            
            if (ub.funcs.isFreeFormToolEnabled(_id)) { 
                if (ub.config.brand.toLowerCase() === "richardson") {
                    _size = 1.5;
                } else {
                    _size = 4;
                }
            }
            
            if (ub.funcs.isCurrentSport('Baseball'))    { _size = 1.5; }
            if (ub.funcs.isCurrentSport('Fastpitch'))   { _size = 2; }

            ub.funcs.setAppSize(_id, _size);

            _settingsObject.accent_obj = ub.funcs.getSampleAccent();
            _settingsObject.text = ub.funcs.getSamplePlayerName();
            _settingsObject.application_type = _applicationType;
            _settingsObject.type = _applicationType;
            _settingsObject.object_type = 'text object';
            _settingsObject.font_obj = ub.funcs.getSampleFont();
            _settingsObject.color_array = ub.funcs.getDefaultColors();

            if (_settingsObject.color_array.length > 1) {
                _settingsObject.color_array = [_settingsObject.color_array[0]];
            }

            _settingsObject.application.name = _applicationType.toTitleCase();
            _settingsObject.application.type = _applicationType;

            // Activate Application
            _settingsObject.status = "on";

            ub.create_application(_settingsObject, undefined);
            ub.current_material.settings.applications[_id] = _settingsObject;

            ub.data.currentApplication = _settingsObject;
            ub.funcs.runAfterUpdate(_id);

            delete ub.current_material.settings.applications[_id].application.views[0].application.appCustomScale;
        });
    },

     /*
        This will create new mascot
        @params perspective, part, side,  _mascotID
    */
    createStockMascot: function(perspective, part, side, _mascotID, callback) {
        var self = this;
        self.createNewApplication(perspective, part, side, function(app) {
            self.utilities.removeApplicationObj(app);

            var _settingsObject = app;
            var _id = parseInt(_settingsObject.code);

            var _applicationType = 'mascot';
            var _size;

            _settingsObject.application_type = _applicationType;
            _settingsObject.type = _applicationType;
            _settingsObject.object_type = _applicationType;
            _settingsObject.mascot = _.find(ub.data.mascots, {id: _mascotID});
            _settingsObject.color_array = ub.funcs.getDefaultColors();
            _settingsObject.isTailSweep = true;
            _settingsObject.application.name = _applicationType.toTitleCase();
            _settingsObject.application.type = _applicationType;

            // Activate Mascot
            _settingsObject.status = "on"

            if (_id === 1) {
                _size = 2;
            }

            if (_id === 2) {
                _size = 8;
            }

            if (_id === 5) {
                _size = 10;
            }

            if (_id === 4) {
                _size = 0.5;
            }

            if (_id === 2 || _id === 5 || _id > 70) {
                _size = 8;
            } else if (_id === 9 || _id === 10 || _id === 32 || _id === 33) {
                _size = 3;
            } else {
                _size = 2;
            }

            if (ub.funcs.isCurrentSport('Wrestling') && ub.current_material.material.type === "upper") {
                _size = 5;
            }

            if (ub.funcs.isCurrentSport('Wrestling') && ub.current_material.material.neck_option === "Fight Short") {
                _size = 5;
            }

            if (!ub.funcs.isCurrentSport('Football') && !ub.funcs.isCurrentSport('Wrestling')) {
                _size = 4;
            }

            if (ub.funcs.isCurrentSport('Football 2017') && (_id === 4 || _id === 7)) {
                _size = 1;
            }

            if (ub.funcs.isCurrentSport('Baseball') && _id === 15) {
                _size = 1.75;
            }

            if (ub.funcs.isCurrentSport('Baseball') && (_id === 7 || _id === 6)) {
                _size = 2;
            }

            if (ub.funcs.isCurrentSport('Fastpitch') && _id === 15) {
                _size = 1.75;
            }

            if (ub.funcs.isCurrentSport('Fastpitch') && (_id === 7 || _id === 6)) {
                _size = 2;
            }

            if (ub.funcs.isSocks()) {
                _size = 2.5;
            }

            if (ub.funcs.isCurrentSport("Baseball") && _.contains([37, 38], _id)) {
                _size = 3;
            }

            if (ub.funcs.isCurrentSport("Baseball") && _.contains([39, 40], _id)) {
                _size = 2;
            }

            if (ub.funcs.isCurrentSport("Fastpitch") && _.contains([37, 38], _id)) {
                _size = 3;
            }

            if (ub.funcs.isCurrentSport("Fastpitch") && _.contains([39, 40], _id)) {
                _size = 2;
            }

            if (ub.funcs.isCurrentSport('Volleyball') && ub.current_material.material.type === "lower") {
                _size = 1;
            }

            if (ub.funcs.isCurrentSport('Volleyball') && ub.current_material.material.type === "upper") {
                _size = 2;
            }

            if (ub.funcs.isCurrentSport("Hockey") && _.contains([2, 5], _id)) {
                _size = 6;
            }

            if (ub.funcs.isCurrentSport("2017 Team Short with Pockets (Apparel)")) {
                _size = 4;
            }

            if (ub.funcs.isCurrentSport("Signature Coaches Short (Apparel)")) {
                _size = 4;
            }

            if (ub.funcs.isCurrentSport('Football') && ub.current_material.material.type === "lower" && ub.config.uniform_application_type === "sublimated") {
                _size = 4;
            }

            ub.funcs.setAppSize(_id, _size);
            ub.funcs.clearInksoftID(_settingsObject); // Remove Inksoft ID from settings object in case it was changed from custom to stock

            var _matchingSide;
            var _matchingID = undefined;
            var _processMatchingSide = true;

            _matchingID = ub.data.matchingIDs.getMatchingID(_id);

            if (_.contains(ub.data.matchingApplications, _id) && typeof _matchingID !== 'undefined') {
                _matchingSide = ub.current_material.settings.applications[_matchingID];

                // On Crew Socks, only duplicate application on matching side is the matching side is blank, otherwise skip this and allow different mascots
                if (_matchingSide.type !== "free" && ub.funcs.isSocks()) {
                    _processMatchingSide = false;
                }

                if (_processMatchingSide) {
                    _matchingSide.application_type = _applicationType;
                    _matchingSide.type = _applicationType;
                    _matchingSide.object_type = _applicationType;
                    _matchingSide.color_array = ub.funcs.getDefaultColors();

                    if (_settingsObject.color_array.length > 1) {
                        _settingsObject.color_array = [_settingsObject.color_array[0]];
                    }

                    _matchingSide.mascot = _.find(ub.data.mascots, {id: _mascotID});

                    if (typeof _matchingSide.color_array === 'undefined') {
                        _matchingSide.color_array = [ub.current_material.settings.team_colors[1],];
                    }

                    _matchingSide.application.name = _applicationType.toTitleCase();
                    _matchingSide.application.type = _applicationType;

                    ub.funcs.setAppSize(_matchingID, _size);
                    ub.funcs.update_application_mascot(_matchingSide.application, _matchingSide.mascot);
                }
            }

            ub.funcs.update_application_mascot(_settingsObject.application, _settingsObject.mascot);
            ub.current_material.settings.applications[_id] = _settingsObject;
            ub.funcs.LSRSBSFS(parseInt(_id));

            ub.data.currentApplication = _settingsObject;
            ub.funcs.runAfterUpdate(_id);

            if (_.isFunction(callback)) {
                callback(_settingsObject)
            }
        })
    },

     /*
        This will create new player number
        @params perspective, part, side, _type, callback
    */
    createNewPlayerNumber: function(perspective, part, side, _type, callback) {
        var self = this;

        self.createNewApplication(perspective, part, side, function(app) {
            self.utilities.removeApplicationObj(app);

            var _settingsObject = app;
            var _id = parseInt(_settingsObject.code);

            var _applicationType = '';
            var _sizeObj = undefined;

            // list of sport block patterns that ignore ub.data.initialSizes
            var blockPatternsException = ['Hockey Socks'];

            // Temporary, this is to fix the issue regarding Hockey Socks (Jan. 25, 2019 @elmer)
            if (!_.contains(blockPatternsException, ub.current_material.material.block_pattern)) {
                _sizeObj = ub.data.initialSizes.getSize(_type, _id, ub.current_material.material.uniform_category);
            } else {
                if (ub.config.type === 'lower' && _.contains(blockPatternsException, ub.current_material.material.block_pattern)) {
                    _sizeObj = ub.data.initialSizesLower.getSize(_type, _id, ub.current_material.material.uniform_category, ub.current_material.material.block_pattern);
                }
            }

            if (typeof _sizeObj !== "undefined") {
                _applicationType = _sizeObj.resultApplicationType;
                _settingsObject.size = _sizeObj.size;
                _settingsObject.font_size = _sizeObj.font_size;

                var _inShoulder = _settingsObject.application.layer.indexOf('Shoulder') !== -1 || _settingsObject.application.layer.indexOf('Cowl') !== -1;
                var _inSleeve = _settingsObject.application.layer.indexOf('Sleeve') !== -1;

                if (_inShoulder) {
                    _applicationType = "shoulder_number";
                }
                if (_inSleeve) {
                    _applicationType = "sleeve_number";
                }

                var _primaryView = ub.funcs.getPrimaryView(_settingsObject.application);

                if (_primaryView === "front" && !(_inShoulder || _inSleeve)) {
                    _applicationType = "front_number";
                }

                if (_primaryView === "back" && !(_inShoulder || _inSleeve)) {
                    _applicationType = "back_number";
                }
            }

            _settingsObject.accent_obj = ub.funcs.getSampleAccent();
            _settingsObject.text = ub.funcs.getSampleNumber();
            _settingsObject.application_type = _applicationType;
            _settingsObject.type = _applicationType;
            _settingsObject.object_type = 'text object';
            _settingsObject.font_obj = ub.funcs.getSampleFont();
            _settingsObject.color_array = ub.funcs.getDefaultColors();

            // Activate Application
            _settingsObject.status = "on";

            if (typeof _settingsObject.color_array === 'undefined') {
                _settingsObject.color_array = [ub.current_material.settings.team_colors[1],];
            }

            if (_settingsObject.color_array.length > 1) {
                _settingsObject.color_array = [_settingsObject.color_array[0]];
            }

            _settingsObject.application.name = _applicationType.toTitleCase();
            _settingsObject.application.type = _applicationType;

            var _matchingID;
            var _matchingSide;

            _matchingID = ub.data.matchingIDs.getMatchingID(_settingsObject.code);

            if (typeof _matchingID !== "undefined") {
                if (_.contains(ub.data.matchingApplications, _id)) {
                    _matchingSide = ub.current_material.settings.applications[_matchingID];
                    _matchingSide.accent_obj = ub.funcs.getSampleAccent();
                    _matchingSide.text = ub.funcs.getSampleNumber();
                    _matchingSide.application_type = _applicationType;
                    _matchingSide.type = _applicationType;
                    _matchingSide.object_type = 'text object';
                    _matchingSide.font_obj = ub.funcs.getSampleFont();
                    _matchingSide.color_array = ub.funcs.getDefaultColors();

                    if (_matchingSide.color_array.length > 1) {
                        _matchingSide.color_array = [_matchingSide.color_array[0]];
                    }

                    _matchingSide.application.name = _applicationType.toTitleCase();
                    _matchingSide.application.type = _applicationType;

                    ub.funcs.setAppSize(_matchingID, _sizeObj.size);
                    ub.create_application(_matchingSide, undefined);
                }
            }

            ub.funcs.setApplicationPatternToDefault(_settingsObject, "318");
            ub.create_application(_settingsObject, undefined);
            ub.current_material.settings.applications[_id] = _settingsObject;

            ub.data.currentApplication = _settingsObject;
            ub.funcs.runAfterUpdate(_id);
            
            if (_.isFunction(callback)) {
                callback(_settingsObject);
            }
            
            delete ub.current_material.settings.applications[_id].application.views[0].application.appCustomScale;
        });
    }
}

/*
    List of function the will manipulate the appearance of application
*/

ApplicationCore.controllers = {
    utilities: ApplicationCore.utilities,
    /*
        This function will change the accent of the application
        @params accentID, application
    */
    changeTextApplicationAccent: function(accentID, application) {
        var self = this;

        self.utilities.changeAccent(accentID, application);
        var matchingID = ub.data.matchingIDs.getMatchingID(application.code);
        if (typeof matchingID !== "undefined") {
            var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matchingID.toString()});
            self.utilities.changeAccent(accentID, _matchingSettingsObject);
        }
    },

    /*
        This function will change the color of the application
        @params application, layer_name, layer_number, colorObject
    */
    changeTextApplicationColor: function(application, layer_name, layer_number, colorObject) {
        // proceed
        var _layer = _.find(application.accent_obj.layers, {name: layer_name});

        _layer.default_color = colorObject.hex_code;
        
        // Save Color Array
        application.color_array[layer_number - 1] = colorObject;

        ub.funcs.changeFontFromPopup(application.font_obj.id, application);
        var _matchingID = ub.data.matchingIDs.getMatchingID(application.code);

        if (typeof _matchingID !== "undefined") {
            var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});
            _layer = _.find(_matchingSettingsObject.accent_obj.layers, {name: layer_name});
            _layer.default_color = colorObject.hex_code;
            _matchingSettingsObject.color_array[layer_number - 1] = colorObject;
            ub.funcs.changeFontFromPopup(_matchingSettingsObject.font_obj.id, _matchingSettingsObject);
        }
    },

    /*
        This function will change the font style of the application
        @params app_id, direction, font_id
    */
    changeTextApplicationFontStyle: function(app_id, direction, font_id) {
        app_id = app_id.toString();
        var application = ub.funcs.getApplicationSettings(app_id);

        var newFont;

        if (direction !== false) {
            newFont = ub.funcs.getFontObj(direction, application.font_obj, application.application_type);
        } else {
            newFont = _.find(ub.data.fonts, {id: font_id.toFixed()});
        }

        if (typeof newFont !== 'undefined') {
            font_id = newFont.id;

            if (_.contains(ub.data.scriptFonts, newFont.alias)) {
                application.text = ub.utilities.titleCase(application.text);
            } else {
                var text = application.text;
                application.text = text.toUpperCase();
            }

            ub.funcs.changeFontFromPopup(font_id, application);

            if (application.type === NumbersPanel.LOCATION_FRONT.type || application.type === NumbersPanel.LOCATION_BACK.type) {
                _.each(ub.current_material.settings.applications, function (application) {
                    if (application.type !== application.application_type && application.type !== NumbersPanel.LOGO_TYPE && application.type !== NumbersPanel.MASCOT_TYPE) {
                        if (application.type.indexOf('number') !== -1 && application.type.indexOf('number') !== -1) {
                            ub.funcs.changeFontFromPopup(font_id, application);
                        }
                    }
                });
            }

            var _matchingID = ub.data.matchingIDs.getMatchingID(app_id);

            if (typeof _matchingID !== "undefined") {
                var matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});
                ub.funcs.changeFontFromPopup(font_id, matchingSettingsObject);
            }

            var font_style_el = $('#font-styles-container');

            font_style_el.find('.font-name').text(newFont.caption);
            font_style_el.find('.font-name').css('font-family', newFont.name);

            if (application.application_type === "team_name") {
                TailSweep.funcs.scriptAndBlockFontTailSweep(application, newFont);
            }

            $('.team-name-panel input.app-letters-input').val(application.text);
            $('#player-name-panel input.app-letters-input').val(application.text);
        } else {
            // No Font!
            return;
        }
    },

     /*
        This function will change the text input of the application
        @params text, application
    */
    changeApplicationText: function(text, application) {
        application.text = text;
        /// Set Auto Font Size on Team Name, Baseball / Fastpitch
        if (parseInt(application.code) === 1 && (ub.funcs.isCurrentSport('Baseball') || ub.funcs.isCurrentSport('Fastpitch'))) {
            if (application.application_type === "team_name") {
                var _len = text.length;
                var _size = application.font_size;

                if (_len <= 4) {
                    _size = 4;
                } else if (_len >= 5 && _len <= 7) {
                    _size = 3;
                } else if (_len >= 8) {
                    _size = 2;
                }

                ub.funcs.setAppSize(application.code, _size);
                ub.funcs.setAUIActiveSize(_size);
            }
        }
        /// End Set Auto Font Size

        ub.funcs.changeFontFromPopup(application.font_obj.id, application);
    }
}